import { get, merge, find, isObject, isArray, map, mapValues } from 'lodash';
import moment from 'moment';
import { localStorage, interpolate, globalConfig } from '../services';
import { zhCN } from '../languages/zh-CN';
import { enUS } from '../languages/en-US';
var LANGUAGE_MARKUP_REGEXP = /<<([^>]+)>>/;
/**
 * 中文国际化语言配置
 */

export var ZH_CN_PRESET = {
  id: 'zh-CN',
  name: '简体中文',
  momentLocale: 'zh-cn',
  antdLocale: undefined,
  context: zhCN
};
/**
 * 英文国际化语言配置
 */

export var EN_US_PRESET = {
  id: 'en-US',
  name: 'English',
  momentLocale: 'en',
  antdLocale: undefined,
  context: enUS
};
export var AVAILABLE_LANGUAGES = [ZH_CN_PRESET];
export var language = {
  /**
   * 初始化语言服务，设置当前系统语言
   * 启用国际化特性需在初始化前设置全局配置 globalConfig.set('features.i18n', true)
   */
  init: init,

  /**
   * 获取当前系统语言信息
   * @returns 前系统语言信息
   */
  getCurrentLanguage: getCurrentLanguage,

  /**
   * 通过属性路径获取当前语言上下文中的对应文本
   * @param  path 属性路径
   * @returns  属性路径对应的文本
   */
  getText: getText,

  /**
   * 注册新语言信息，当语言已存在时，新注册的语言信息会合并至旧语言信息中
   * 语言信息结构 { id, name, momentLocale, antdLocale, context }
   * @param languagePackage 语言信息
   */
  registerLanguage: registerLanguage,

  /**
   * 将输入的配置信息片段中的多语言插值表达式替换为当前语言上下文中的文本
   * @param config 配置信息片段
   * @returns 替换后的配置信息片段
   */
  parse: parse,

  /**
   * 切换语言，需要先启用国际化特性
   * @param languageId 语言 id
   */
  changeTo: changeTo
};
var currentLanguage;

function init() {
  if (currentLanguage) {
    return;
  }

  if (globalConfig.get('features.i18n')) {
    var result = find(AVAILABLE_LANGUAGES, {
      id: localStorage.get('language') || navigator.language
    });
    currentLanguage = result ? result : AVAILABLE_LANGUAGES[0];
  }

  if (!currentLanguage) {
    currentLanguage = AVAILABLE_LANGUAGES[0];
  }

  moment.locale(currentLanguage.momentLocale);
}

function getCurrentLanguage() {
  if (!currentLanguage) {
    throw new Error('language serivces not initialized.');
  }

  return currentLanguage;
}

function getText(path) {
  if (!currentLanguage) {
    throw new Error('language serivces not initialized.');
  }

  return get(currentLanguage.context, path);
}

function registerLanguage(languagePackage) {
  if (!isObject(languagePackage)) {
    throw new Error('Invalid language package.');
  }

  var id = languagePackage.id;

  if (!id) {
    throw new Error('Invalid language package.');
  }

  var language = find(AVAILABLE_LANGUAGES, {
    id: id
  });

  if (language) {
    merge(language, languagePackage);
  } else {
    AVAILABLE_LANGUAGES.push(languagePackage);
  }
}
/**
 * 检查配置文件是否需要多语言替换
 * @param config 配置文件
 */


function isNeedParse(config) {
  return LANGUAGE_MARKUP_REGEXP.test(JSON.stringify(config));
}

function parse(config) {
  if (!isNeedParse(config)) {
    return config;
  }

  if (isArray(config)) {
    return map(config, parse);
  }

  if (isObject(config)) {
    return mapValues(config, parse);
  }

  return interpolate(config, currentLanguage.context, LANGUAGE_MARKUP_REGEXP);
}

function changeTo(languageId) {
  if (globalConfig.get('features.i18n')) {
    localStorage.set('language', languageId);
    window.location.reload();
  }
}